import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  GatewayConfig,
  SHARED_GATEWAY_CONFIG,
} from '@cigna/shared/angular/gateways-util';

interface Response {
  data: {
    authnUrl: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class LinkRouterService {
  constructor(
    private _http: HttpClient,
    @Inject(SHARED_GATEWAY_CONFIG) private _config: GatewayConfig,
  ) {}

  getPublic() {
    return this.request(this._config.publicLinkRouter);
  }

  getSecure() {
    return this.request(this._config.privateLinkRouter);
  }

  private request(url: string) {
    const params = new URLSearchParams(window.location.search);
    const appId = params.get('key');
    params.delete('key');
    // build pipeline has issues with this line, casting as any for now
    // while we figure out what's going on
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requestParams = Object.fromEntries(params as any);
    return this._http.post<Response>(url, {
      appId,
      params: requestParams,
    });
  }
}
